export const h = {
    "common": {
        "webSuffix": "-QIDI Tech",
        "email": "posta kutusu",
        "password": "Şifre",
        "verificationCode": "doğrulama kodu",
        "username": "Kullanıcı Adı",
        "readAndAgree": "katılıyorum",
        "and": "ve",
        "userAgreement": "Kullanıcı",
        "privacyPolicy": "Gizlilik politikası",
        "copy": "Telif Hakkı © 2025 QIDI Tüm hakları saklıdır",
        "sendVerificationCode": "Doğrulama kodu gönder",
        "Sending": "gönderiyor",
        "tryAgainInSeconds": "saniye sonra tekrar deneyin",
        "userNameRequired": "Lütfen kullanıcı adını girin",
        "passwordInputLabel": "Lütfen şifreyi girin",
        "checkPasswordInputLabel": "Lütfen onay şifresini girin",
        "userEmailRequired": "Lütfen e-posta adresini girin",
        "userEmailInvalid": "Lütfen doğru e-posta adresini girin",
        "emailCodeRequired": "Lütfen doğrulama kodu girin",
        "newPasswordInputLabel": "Lütfen yeni bir şifre girin",
        "confirmPasswordInputLabel": "Lütfen şifreyi tekrar girin",
        "passwordMismatchErrorLabel": "İki kez girilen şifre tutarsız",
        "agreementRequired": "Lütfen anlaşmayı okuyun ve kabul",
        "tip": "ipucu",
        "tipAlreadyLogin": "Giriş yaptığınız tespit edildi ve sizin için Kullanıcı Merkezi'ne atlayın",
        "tipWelcomeBack": "Tekrar hoş geldiniz ~",
        "tipDeleteAccountFail": "Hesap silinemedi, hesap silme arayüzü geçici olarak kapatıldı",
        "pleaseAgreeFirst": "Lütfen önce kabul edin",
        "agree": "anlaştı",
        "refuse": "reddedildi",
        "tipNeedLogin": "lütfen önce giriş yapın",
        "tipChangePasswordSuccess": "Şifre başarılı bir şekilde değiştirildi, oturum açma sayfasına atladınız",
        "tipGetUserInfoSuccess": "Bilgi alma başarısı",
        "tipGetUserInfoFail": "Bilgi alınamadı",
        "tipLoginOut": "Çıkış Giriş",
        "delete": "sil",
        "back": "Dönüş",
        "init": "Başlatma",

        "passwordInputLengthErrorLabel": "Şifre uzunluğu 6 ila 20 arasında olmalıdır",
        "changePasswordFail": "Orijinal şifre yanlış",
        "tipDeleteAccountSuccess": "Hesap başarılı silindi",
        "emailCodeSentSuccess": "Doğrulama kodu gönderildi",
        "emailCodeSentFail": "Doğrulama kodu gönderilemedi",
        "emailLoginFail": "Doğrulama kodu süresi doldu",
        "passwordLoginFail": "Giriş şifresi yanlış",
        "editUserInfoSuccess": "Kullanıcı bilgileri başarılı bir",
        "registerSuccess": "başarılı kayıt",
        "registerFail": "Kayıt",
        "registerEmailExistFail": "Posta kutusu zaten var",

        "resMessageTip0": "Bilinmeyen bilgiler",
        "resMessageTip1": "Yanlış şifre",
        "resMessageTip2": "Şifre uzunluğu 6 ila 20 arasında olmalıdır",
        "resMessageTip3": "hesap hatası",
        "resMessageTip4": "Doğrulama kodu gönderildi",
        "resMessageTip5": "Doğrulama kodu gönderilemedi",
        "resMessageTip6": "Doğrulama kodu süresi doldu",
        "resMessageTip7": "Yanlış şifre",
        "resMessageTip8": "Şifre eski şifreyle aynı olamaz",
        "resMessageTip9": "Posta kutusu zaten var",
        "resMessageTip10": "başarılı kayıt",
        "resMessageTip11": "Kayıt",
        "resMessageTip12": "Kullanıcı bilgileri başarılı bir",
        "resMessageTip13": "Kullanıcı bilgilerinin",
        "resMessageTip14": "Başarılı olun",
        "resMessageTip15": "Alınma başarısız",
        "resMessageTip16": "Şifre başarıyla",
        "resMessageTip17": "Şifre değiştirilemedi",
        "resMessageTip18": "Şifre sıfırlaması başarılı",
        "resMessageTip19": "Parola sıfırlama başarısız oldu",
        "resMessageTip20": "başarılı giriş",
        "resMessageTip21": "Giriş",
        "resMessageTip22": "Hesap başarılı silindi",
        "resMessageTip23": "Hesap silinemedi",
        "resMessageTip24": "Doğrulama kodu yanlış",
        "noUserInfoError": "Ağ hatası, lütfen tekrar giriş yapın"
    },
    "changePassword": {
        "newPassword": "Yeni şifre"
    },
    "deleteUser": {
        "tipDeleteUser": "Ayrıldığınız için üzgünüm. Hesabınız silindikten sonra, tüm kişisel verileriniz kalıcı olarak kaybolacak ve kurtarılamayacaktır.",
        "accountDeletionTerms": "Hesap silme koşulları"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "E-posta yoluyla şifreyi geri",
        "confirmPassword": "Şifreyi onayla",
        "resettingPassword": "Şifreyi Sıfırla",
        "resetting": "Sıfırlama"
    },
    "login": {
        "passwordLogin": "Şifre Giriş",
        "verifyLogin": "Giriş",
        "accountRegistration": "Hesap Kaydı",
        "forgotPassword": "Şifremi",
        "login": "Giriş",
        "localLogin": "Yerel Giriş",
        "loginOut": "Çıkış Çıkışı",
        "continueOnYourWay": "devam edin"
    },
    "register": {
        "registerAnAccount": "Hesap Kaydet",
        "register": "Kayıt"
    },
    "userCenter": {
        "personalInformation": "Kişisel Bilgiler",
        "modifyInformation": "Bilgileri Değiştir",
        "changePassword": "Şifreyi değiştir",
        "cancelAccount": "Hesabı iptal et",
        "exitAccount": "Hesabından çıkış",
        "change": "Modifiye",
        "maxCharLimitTip": "Kullanıcı adı uzunluğu 10 Çince karakterden fazla olamaz",
    },
    "policies": {
        "deleteAccountPrivacy": "Hesap sözleşmesini sil",
        "agreement": "Kullanım Protokolü",
        "privacyPolicy": "Gizlilik politikası"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Ülkenizi veya bölgenizi seçin",
        "recommendedVisits": "Önerilen ziyaret",
        "NorthAmerica": "Kuzey Amerika",
        "Europe": "Avrupa",
        "Asia": "Asyalı",
        "Other": "Diğer",
    }
}
export const aAndL ={
    "ar": {
        "Country": "Arap",
        "Language": "Arapça"
    },
    "cs": {
        "Country": "Çek",
        "Language": "Çekçe"
    },
    "de": {
        "Country": "Alman",
        "Language": "Almanca"
    },
    "en": {
        "Country": "Birleşik",
        "Language": "İngilizce"
    },
    "es": {
        "Country": "İspanya",
        "Language": "İspanya"
    },
    "fr": {
        "Country": "Fransa",
        "Language": "Fransızca"
    },
    "he": {
        "Country": "İsrail",
        "Language": "İbranice"
    },
    "hu": {
        "Country": "Macaristan",
        "Language": "Macarca"
    },
    "it": {
        "Country": "İtalya",
        "Language": "İtalyanca"
    },
    "ja": {
        "Country": "Japonya'da",
        "Language": "Japonca"
    },
    "ko": {
        "Country": "Kore",
        "Language": "Korece"
    },
    "nl": {
        "Country": "Hollanda",
        "Language": "Hollandalı"
    },
    "pt": {
        "Country": "Portekiz",
        "Language": "Portekizce"
    },
    "pt_BR": {
        "Country": "Portekiz (Brezilya)",
        "Language": "Portekizce (Brezilya)"
    },
    "ru": {
        "Country": "Rusya",
        "Language": "Rusça"
    },
    "sv": {
        "Country": "İsveç",
        "Language": "İsveççe"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Türkçe"
    },
    "uk": {
        "Country": "Ukrayna",
        "Language": "Ukraynalı"
    },
    "zh": {
        "Country": "Çin anakarası",
        "Language": "Basitleştirilmiş Çince"
    },
    "zh_tw": {
        "Country": "Tayvan Çin",
        "Language": "Geleneksel Çince"
    },
    "Canada": {
        "Country": "Kanada",
        "Language": "İngilizce"
    },
    "United_States": {
        "Country": "Amerikalı",
        "Language": "İngilizce"
    },
    "United_Kingdom": {
        "Country": "Birleşik",
        "Language": "İngilizce"
    },
    "EU_Countries": {
        "Country": "AB Ülkeleri",
        "Language": "İngilizce"
    },
    "Australia": {
        "Country": "Avustralya",
        "Language": "İngilizce"
    },
    "globalzh": {
        "Country": "Küresel",
        "Language": "Basitleştirilmiş Çince"
    },
    "globalen": {
        "Country": "Küresel",
        "Language": "İngilizce"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/tr.js